<template>
  <div class="wrapper">
    <base-circular-loader v-if="loading" />

    <div v-else class="list">
      <base-search class="list-header"
                   @search="onSearch" />

      <div v-for="(app, index) in apps"
           class="list-item list-item-no-border list-item-sm"
           :key="index">
        <app-settings-item :app="app"
                            :child-id="childId"
                            @changeAction="changeAction" />
      </div>
    </div>
  </div>
</template>

<script>
  import AppSettingsItem from '@/components/Child/ChildAppSettings/AppSettingsItem.vue'
  import analytics from '@/services/analytics.js'
  import { filter } from '@/services/utils'

  export default {
    props: {
      modeId: {
        type: String,
        required: true
      },

      childId: {
        type: String,
        required: true
      },

      appType: {
        type: String,
        required: true
      }
    },

    components: {
      AppSettingsItem
    },

    data() {
      return {
        loading: true,
        keyword: '',
        apps: []
      }
    },

    async created() {
      analytics.sendEvent('AppStgs_Sc')

      await this.getAppsData()
      this.initApps(this.appType)
    },

    methods: {
      ...mapActions('children', {
        loadBlockableApps: 'loadBlockableApps',
        loadAppSettings: 'loadAppSettings',
        updateAppSettings: 'updateAppSettings'
      }),

      initApps(appType) {
        this.apps = filter(this.blockableApps[appType], this.keyword, 'label')
      },

      async getAppsData() {
        this.loading = true

        await this.loadBlockableApps(this.childId)
        await this.loadAppSettings({
          user_id: this.childId,
          mode_id: this.standardMode.id
        })

        this.loading = false
      },

      onSearch(keyword) {
        this.keyword = keyword
      },

      changeAction(app) {
        const { id, action } = app

        this.updateAppSettings({
          user_id: this.childId,
          mode_id: this.modeId,
          app_id: id,
          action
        })
      }
    },

    computed: {
      ...mapGetters('children', {
        getAndroidApps: 'getAndroidApps',
        getIosApps: 'getIosApps'
      }),

      ...mapGetters('children', {
        getChildById: 'getById',
      }),

      child() {
        return this.getChildById(this.childId)
      },

      standardMode() {
        return this.child.modes.find(mode => mode.name === 'Standard')
      },

      androidApps() {
        return this.getAndroidApps(this.childId)
      },

      iosApps() {
        return this.getIosApps(this.childId)
      },

      blockableApps() {
        return {
          'android': this.androidApps,
          'ios': this.iosApps
        }
      }
    },

    watch: {
      appType(appType) {
        this.initApps(appType)
      },

      keyword() {
        this.initApps(this.appType)
      }
    }
  }
</script>